import { type ComponentPropsWithoutRef } from 'react'
import clsx from 'clsx'
import { badge, type BadgeVariants } from './Badge.css'

type BadgeProps = {
  /** Badge content */
  children: React.ReactNode
  /** Additional CSS class names */
  className?: string
} & BadgeVariants &
  Omit<ComponentPropsWithoutRef<'span'>, 'children'>

/**
 * A pill-shaped badge for displaying status or count indicators.
 *
 * @example
 * ```tsx
 * <Badge color="success">Active</Badge>
 * <Badge color="caution" variant="outline">Draft</Badge>
 * <Badge color="error">Rejected</Badge>
 * <Badge color="info">3 new</Badge>
 * ```
 */
export function Badge({ variant, color, size, className, children, ...props }: BadgeProps) {
  return (
    <span className={clsx(badge({ variant, color, size }), className)} {...props}>
      {children}
    </span>
  )
}
